export const Constant = {
  DEFAULT_DURATION_IN_MS: 500,
  DEFAULT_DELAY_IN_MS: 0,

  MIN_SKEW_X: 0,
  MAX_SKEW_X: -Math.PI / 4,

  INITIAL_TRANSLATE_X: 300,
  FINAL_TRANSLATE_X: 0,
};
